import VideoPlayComponent from './VideoPlay.vue'

let $vm

export default {
    install (Vue) {
        const VideoPlay = Vue.extend(VideoPlayComponent)

        if (!$vm) {
            $vm = new VideoPlay({el: document.createElement('div')})
            document.body.appendChild($vm.$el)
        }

        Vue.$videoplay = {
            open (uri) {
                $vm.open(uri)
            },
            close () {
                $vm.close()
            }
        }

        Vue.mixin({
            created () {
                this.$videoplay = Vue.$videoplay
            }
        })
    }
}